import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['row', 'header']

  connect() {
    this.numeric = false;
    this.date = false;
    this.dir = ""
    this.header = null;
  }

  sortBy(event) {
    const header = event.target.closest('[data-sort-target="header"]') || event.target;
    if (this.header !== header) {
      this.dir = ""
    }
    this.header = header;
    this.numeric = header.classList.contains('numeric');
    this.date = header.classList.contains('date');
    let idx = this.headerTargets.indexOf(header);
    if (idx !== -1) this.sort(idx);
  }

  sortList(list, idx) {
    const children = Array.from(list.children);
    if (children.length <= 1) return;

    const itemsWithValues = children.map(li => {
      const targetElement = li.querySelector(".filter-type")?.children[idx];
      const rawText = targetElement ? targetElement.textContent.trim() : "";

      let parsedValue;
      if (this.numeric) {
        parsedValue = parseFloat(rawText.replace(/[^\d.]/g, "")) || 0;
      } else if (this.date) {
        parsedValue = this.convertDotDateToJSDate(rawText).getTime();
      } else {
        parsedValue = rawText.toLowerCase();
      }

      return { element: li, value: parsedValue };
    });

    itemsWithValues.sort((a, b) => {
      if (this.numeric || this.date) {
        return this.dir === "desc" ? b.value - a.value : a.value - b.value;
      }
      const comparison = a.value.localeCompare(b.value, "ru");
      return this.dir === "desc" ? -comparison : comparison;
    });

    const fragment = document.createDocumentFragment();
    itemsWithValues.forEach(item => fragment.appendChild(item.element));
    list.appendChild(fragment);
  }

  sort(index) {
    this.dir = (this.dir === "asc") ? "desc" : "asc";

    const lists = document.querySelectorAll('ul.subtree.with_children');
    for (let i = lists.length - 1; i > -1; i -= 1) {
      this.sortList(lists[i], index);
    }

    this.headerTargets.forEach((element, i) => {
      const isActive = (i === index);
      element.classList.toggle("asc", isActive && this.dir === "asc");
      element.classList.toggle("desc", isActive && this.dir === "desc");
    });

    const rootSubtree = document.querySelector('ul.subtree');
    if (rootSubtree) {
      this.application.getControllerForElementAndIdentifier(rootSubtree, "subtree")?.connect();
      this.application.getControllerForElementAndIdentifier(rootSubtree, "visible")?.connect();
    }
  }

  convertDotDateToJSDate(string) {
    const trimmed = string.trim();
    if (!trimmed || trimmed === "—") {
      return new Date(2200, 0, 1);
    }
    const parts = trimmed.split('.');
    if (parts.length !== 3) return new Date(2000, 0, 1);

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }
}
